import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";

import { z } from "zod";

// Zod schema for form validation
export const userSchema = z.object({
  first_name: z.string().min(1, "First Name is required"),
  last_name: z.string().min(1, "Last Name is required"),
  email: z.string().email("Please enter a valid email."),
  organization: z.string().min(1, "Organization is required"),
});
export type UserFormData = z.infer<typeof userSchema>;

export const updateUserSchema = z.object({
  first_name: z.string().min(1, "First Name is required"),
  last_name: z.string().min(1, "Last Name is required"),
  email: z.string().email("Please enter a valid email."),
  organization: z.string().min(1, "Organization is required"),
});
export type UpdateUserForm = z.infer<typeof updateUserSchema>;

export const createUser = async (
  createUserParam: UserFormData
): Promise<any> => {
  const { data } = await axiosClient.post(
    ENDPOINTS.BASE_ADMIN_USERS,
    createUserParam
  );
  return data;
};

export const updateUser = async ({
  userId,
  updateUserParams,
}: {
  userId: string;
  updateUserParams: UpdateUserForm;
}): Promise<any> => {
  const { data } = await axiosClient.put(
    `${ENDPOINTS.BASE_ADMIN_USERS}/${userId}`,
    updateUserParams
  );
  return data;
};

export const deleteUser = async (userId: string): Promise<any> => {
  const { data } = await axiosClient.delete(
    `${ENDPOINTS.BASE_ADMIN_USERS}/${userId}`
  );

  return data;
};
